import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { Component, createRef } from 'react';

import { Button, Card, CardBody, CardGroup, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink  } from 'reactstrap';
import { IStackTokens, Stack } from '@fluentui/react/lib/Stack';
import { Dropdown, IDropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption,} from '@fluentui/react/lib/Dropdown';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { TextField, MaskedTextField } from '@fluentui/react/lib/TextField';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { ChoiceGroup, IChoiceGroupOption } from '@fluentui/react/lib/ChoiceGroup';
const dropdownStyles = {
	dropdown: { width: 300 },
  };
  const stackTokens = { childrenGap: 20 };
const options_Organisms = [
	{ key: '', text: 'Select an option'},
	{ key: '%Bacteria%', text: 'Bacteria'},
	{ key: '%Dictyostelium_discoideum%', text: 'Dictyostelium Discoideum'},
	{ key: '%Human%', text: 'Human'},
	{ key: '%Mouse%', text: 'Mouse'},
	{ key: '%Protozoan%', text: 'Protozoan'},
	{ key: '%Rat%', text: 'Rat'},
];

const options_Dnase = [
	{ key: '', text: 'Select an option'},
	{ key: '%Benzonase%', text: 'Benzonase'},
	{ key: '%DNase%', text: 'DNase'},
	{ key: '%Exonuclease%', text: 'Exonuclease'},
	{ key: '%Nuclease%', text: 'Nuclease'},
	{ key: '%MNase%', text: 'MNase'},
	{ key: '%Proteinase%', text: 'Proteinase'},
	{ key: '%RNase%', text: 'RNase'},
	{ key: '%RsaI%', text: 'RsaI'},
	{ key: '%No%', text: 'Not reported/No Treat'},
];

const options_Yearofpublications = [
	{ key: '', text: 'Select an option'},
	{ key: '1995', text: '1995'},
	{ key: '1997', text: '1997'},
	{ key: '2004', text: '2004'},
	{ key: '2008', text: '2008'},
	{ key: '2009', text: '2009'},
	{ key: '2010', text: '2010'},
	{ key: '2011', text: '2011'},
	{ key: '2012', text: '2012'},
	{ key: '2013', text: '2013'},
	{ key: '2014', text: '2014'},
	{ key: '2015', text: '2015'},
	{ key: '2016', text: '2016'},
	{ key: '2017', text: '2017'},
	{ key: '2018', text: '2018'},
	{ key: '2019', text: '2019'},
	{ key: '2020', text: '2020'},
	{ key: '2022', text: '2022'},
	{ key: '2023', text: '2023'},
];

const options_EVsubtypesstudied = [
	{ key: '', text: 'Select an option'},
	{ key: '%Apoptotic bodies%', text: 'Apoptotic bodies'},
	{ key: '%Ectosomes%', text: 'Ectosomes'},
	{ key: '%Exomeres%', text: 'Exomeres'},
	{ key: '%Exosome%', text: 'Exosomes'},
	{ key: '%Extracellular_DNA%', text: 'Extracellular DNA'},
	{ key: '%Extracellular_vesicles%', text: 'Extracellular vesicles'},
	{ key: '%large_Extracellular_vesicles%', text: 'Extracellular vesicles'},
	{ key: '%nano_Extracellular_vesicles%', text: 'Extracellular vesicles'},
	{ key: '%small_Extracellular_vesicles%', text: 'Extracellular vesicles'},
	{ key: '%Membrane_vesicles%', text: 'Membrane vesicles'},
	{ key: '%Microparticles%', text: 'Microparticles'},
	{ key: '%Microvesicles%', text: 'Microvesicles'},
	{ key: '%Outer_membrane_vesicle%', text: 'Outer membrane vesicle'},
	{ key: '%Prostasomes%', text: 'Prostasomes'},
	{ key: '%Tumor_Microvesicles%', text: 'Tumor Microvesicles'},
	{ key: '%Tumor_cell_derived_microparticles%', text: 'Tumor cell-derived microparticles'},
];

const options_EVIsolationmethod = [
	{ key: '', text: 'Select an option'},
	{ key: '%Asymmetric_flow_field_flow_fractionation%', text: 'Asymmetric flow field-flow fractionation'},
	{ key: '%CD9_immunoprecipitation_kit%', text: 'CD9 immunoprecipitation kit'},
	{ key: '%Centrifugation%', text: 'Centrifugation'},
	{ key: '%Cushioned_density_gradient %', text: 'Cushioned-density gradient '},
	{ key: '%Direct_immunoaffinity_capture%', text: 'Direct immunoaffinity capture'},
	{ key: '%ExoEasy%', text: 'ExoEasy'},
	{ key: '%ExoEnrich%', text: 'ExoEnrich'},
	{ key: '%ExoQuick%', text: 'ExoQuick'},
	{ key: '%Filtration%', text: 'Filtration'},
	{ key: '%High_resolution_density_gradient_fractionation%', text: 'High-resolution density gradient fractionation'},
	{ key: '%Invitrogen%', text: 'Invitrogen'},
	{ key: '%Lipid_nanoprobe%', text: 'Lipid nanoprobe'},
	{ key: '%Optiprep%', text: 'Optiprep'},
	{ key: '%PEG_precipitation%', text: 'PEG precipitation'},
	{ key: '%PEG_Based_Exosome_Isolation%', text: 'PEG-Based Exosome Isolation'},
	{ key: '%Size_exclusion_chromatography%', text: 'Size exclusion chromatography'},
	{ key: '%Sucrose_density_gradient%', text: 'Sucrose density gradient'},
	{ key: '%Tangential_flow_filteration_column%', text: 'Tangential flow filteration column'},
	{ key: '%Total_Exosome_Isolation_Reagent%', text: 'Total exosome isolation reagent'},
	{ key: '%Umibio%', text: 'Umibio'},
	{ key: '%No%', text: 'Not reported'},
];
const options_search: IChoiceGroupOption[] = [
	{ key: '/search', text: 'Biofluids' },
	{ key: '/search_in_vitro', text: 'In-Vitro' },
	{ key: '/search_in_vivo', text: 'In-Vivo' },
  ];
const option_to_name = [
	{ key: '', text: 'Select an option'},
	{ key: 'Organisms', text: 'Organisms'},
	{ key: 'Cell Types', text: 'Celltypes'},
	{ key: 'Enzyme and Detergent', text: 'Dnase'},
	{ key: 'Year of Publications', text: 'Yearofpublications'},
	{ key: 'EV Type', text: 'EVsubtypesstudied'},
	{ key: 'EV isolation methods', text: 'EVIsolationmethod'},
	{ key: 'Author', text: 'Reference'},
	{ key: 'Method of detection', text: 'Methodsofgenedetection'},
	{ key: 'EVTrack ID', text: 'EVTrackID'},
	{ key: 'PubMed ID', text: 'PubmedID'},
];

function App() {
	const [selectedKey, setSelectedKey] = React.useState('/search_in_vitro');
	const [Organisms,setOrganisms] = React.useState({ key: '', text: ''});
	const [Celltypes,setCelltypes] = React.useState('');
	const [Dnase,setDnase] = React.useState({ key: '', text: ''});
	const [Yearofpublications,setYearofpublications] = React.useState({ key: '', text: ''});
	const [EVsubtypesstudied,setEVsubtypesstudied] = React.useState({ key: '', text: ''});
	const [EVIsolationmethod,setEVIsolationmethod] = React.useState({ key: '', text: ''});
	const [Reference,setReference] = React.useState('');
	const [EVTrackID,setEVTrackID] = React.useState('');
	const [PubMedID,setPubMedID] = React.useState('');
	const [Methodsofgenedetection,setMethodsofgenedetection] = React.useState('');
	const onChange = (ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void => {
		setSelectedKey(option.key);
		window.location.href = option.key
		// Perform other actions here, such as setting state or updating context
	  };
	return (
<Stack style={{marginBottom:40}} verticalAlign='true' wrap = 'true' >
<Stack horizontalAlign="center" horizontal="true">
<ChoiceGroup
      label="Search Type"
      selectedKey={selectedKey}
      options={options_search}
      onChange={onChange}
      required={true}
	  styles={{
        flexContainer: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          // Add gap between radio buttons
          '> *:not(:last-child)': {
            marginRight: 10,
          },
        },
      }}

    />
</Stack>

<Stack horizontalAlign="center" horizontal="true" gap = "20" >
	<Dropdown
			placeholder="Select an option"
			label={"Organisms"}
			options={options_Organisms}
			styles={dropdownStyles}
			onChange = {(e,option) => {setOrganisms(option);}}
		/>
		<TextField 
			label="Enter a cell type"
			onChange={(e,txt) => {setCelltypes(txt);}}
			styles={{fieldGroup: { width: 300 }}}
	/>
		
</Stack>

<Stack horizontalAlign="center" horizontal="true" gap = "20" >
	<Dropdown
			placeholder="Select an option"
			label={"Enzyme and Detergent"}
			options={options_Dnase}
			styles={dropdownStyles}
			onChange = {(e,option) => {setDnase(option);}}
		/>
		<Dropdown
		placeholder="Select an option"
		label={"Year of publications"}
		options={options_Yearofpublications}
		styles={dropdownStyles}
		onChange = {(e,option) => {setYearofpublications(option);}}
	/>
		
</Stack>



<Stack horizontalAlign="center" horizontal="true" gap = "20" style={{marginRight:220}}>
<Dropdown
		placeholder="Select an option"
		label={"EV Type"}
		options={options_EVsubtypesstudied}
		styles={{dropdown: { width: 400 }}}
		onChange = {(e,option) => {setEVsubtypesstudied(option);}}
		defaultSelectedKeys = {0}
	/>
</Stack>

<Stack horizontalAlign="center" horizontal="true" gap = "20">
<Dropdown
		placeholder="Select an option"
		label={"EV isolation methods"}
		options={options_EVIsolationmethod}
		styles={{dropdown: { width: 620 }}}
		onChange = {(e,option) => {setEVIsolationmethod(option);}}
	/>

</Stack>


<Stack horizontalAlign="center" horizontal="true" gap = "20">
<TextField 
			label="Method of Detection"
			onChange={(e,txt) => {setMethodsofgenedetection(txt);}}
			styles={{fieldGroup: { width: 300 }}}
		/>
	<TextField 
			label="Author"
			onChange={(e,txt) => {setReference(txt);}}
			styles={{fieldGroup: { width: 300 }}}
		/>


</Stack >

<Stack horizontalAlign="center" horizontal="true" gap = "20">
<TextField 
			label="EVTrack ID"
			onChange={(e,txt) => {setEVTrackID(txt);}}
			styles={{fieldGroup: { width: 300 }}}
		/>
	<TextField 
			label="PubMed ID"
			onChange={(e,txt) => {setPubMedID(txt);}}
			styles={{fieldGroup: { width: 300 }}}
		/>


</Stack >

<Stack  horizontalAlign = "center" childrenGap = "100" horizontal>

	{/*<Stack style={{marginTop:30, marginLeft:71}} tokens={stackTokens} horizontal childrenGap = {20}>*/}
	<Stack style={{marginTop:30}} tokens={stackTokens} horizontal childrenGap = {20}>	
	<PrimaryButton 
		styles = {{}}
		text="Whole Database" 
		onClick={() =>{
			window.alert("This will show the whole dataset")
			//window.open("/ev_database")
			window.location.href = "/ev_database_in_vitro"
		}}
	/>
	<PrimaryButton 
		styles = {{}}
		text="Search" 
		onClick={() =>{
		let prefix = 'wpda_search_column_'
		let begin = '/ev_database_in_vitro/?'
		let result = begin
		if (Organisms.key != ''){
			result = result.concat(prefix,option_to_name[1].text,"=",Organisms.key,"&")
		}
		if (Celltypes != ''){
			result = result.concat(prefix,option_to_name[2].text,"=%",Celltypes,"%&")
		}
		if (Dnase.key != ''){
			result = result.concat(prefix,option_to_name[3].text,"=",Dnase.key,"&")
		}
		if (Yearofpublications.key != ''){
			result = result.concat(prefix,option_to_name[4].text,"=",Yearofpublications.key,"&")
		}
		if (EVsubtypesstudied.key != ''){
			result = result.concat(prefix,option_to_name[5].text,"=",EVsubtypesstudied.key,"&")
		}
		if (EVIsolationmethod.key != ''){
			result = result.concat(prefix,option_to_name[6].text,"=",EVIsolationmethod.key,"%&")
		}
		if (Reference != ''){
			result = result.concat(prefix,option_to_name[7].text,"=","%",Reference,"%_rl%&")
		}
		if (Methodsofgenedetection != ''){
			result = result.concat(prefix,option_to_name[8].text,"=","%",Methodsofgenedetection,"%&")
		}
		if (EVTrackID != ''){
			result = result.concat(prefix,option_to_name[9].text,"=","",EVTrackID,"&")
		}
		if (PubMedID != ''){
			result = result.concat(prefix,option_to_name[10].text,"=","",PubMedID,"&")
		}
		if (result == begin){
			window.alert("No search criteria. This will show the whole dataset")
			window.location.href = "/ev-database-in-vitro"
			//window.open("/ev_database")
		}else{
			//window.open(result)
			result = result.replace(/ /g,"_");
			result = result.replaceAll("-","_");
			result = result.replaceAll("‐","_");
			window.location.href = result
		}
		
		}}
		
		allowDisabledFocus 
		disabled={false} 
		checked={false} 
	/>

	</Stack >
	</Stack>
	</Stack>
  );
};

export default App;